import React from "react";
import "./Nav.css";
import { useLocation } from "react-router-dom";
import openLeagueLogo from "../../img/open_league_logo.png";
export default function Nav(props) {
  const location = useLocation();
  const isAdmin = location.pathname.includes("admin") ? true : false;
  return isAdmin ? (
    <div className="nav">
      <div className="matches-container">
        <a href="/admin">Mecze</a>
      </div>
      <div className="matches-container">
        <a href="/admin/new">Dodaj mecz</a>
      </div>

      <div className="matches-container">
        <a href="/entry">Strefa gracza</a>
      </div>
    </div>
  ) : (
    <div className="nav">
      <div className="matches-container">
        <a href="/">Mecze</a>
      </div>
      <img src={openLeagueLogo} width={"60px"} />
      <div className="matches-container">
        <a href="/entry">Strefa gracza</a>
      </div>
    </div>
  );
}
